import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
import { memo, useMemo, useState } from 'react';
import { DashboardSettingsContent, default_config, } from './types';
export const Z3KDashboardSettingsProvider = memo(function Z3KDashboardSettingsProvider(props) {
    const { children } = props;
    const { dashboard_settings } = useAppSelector(select_ui_settings);
    const [dashboard_config, setDashboardConfig] = useState(dashboard_settings ?? default_config);
    const content = useMemo(() => ({
        dashboard_config,
        setDashboardConfig,
    }), [dashboard_config, setDashboardConfig]);
    return (_jsx(DashboardSettingsContent.Provider, { value: content, children: children }));
});
